import { FC, MouseEvent } from 'react';

import OperationType from '../OperationType';

import { parseOperationType } from '../../lib';
import { GraphQLQuery as GraphQLQueryType } from '../../types';

import styles from './GraphQLQueryRow.module.css';

type Props = {
  query: GraphQLQueryType;
  selected?: boolean;
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
};

const GraphQLQueryRow: FC<Props> = ({ query, selected, onClick }) => {
  if (!query.request.body) return null;

  const body = JSON.parse(query.request.body.toString());
  const { type, name } = parseOperationType(body.query);

  return (
    <div
      className={`${styles.root} ${selected && styles.selected}`}
      onClick={onClick}>
      <OperationType type={type} /> {name}
    </div>
  );
};

export default GraphQLQueryRow;
